function adjustImageCta() {
  const isMobile = window.innerWidth <= 767;
  const grid = document.querySelector('#bls__product-grid');
  if (!grid) return;

  [...grid.querySelectorAll('.bls__grid__item[data-product-index]')].forEach((item) => {
    item.style.display = '';
  });

  const allCtas = [...grid.querySelectorAll('.image-cta-block')];
  const seenPositions = new Set();
  const toKeep = [];

  allCtas.forEach((cta) => {
    const key = `${cta.dataset.position}-${cta.dataset.positionMobile}`;
    if (seenPositions.has(key)) {
      cta.remove();
    } else {
      seenPositions.add(key);
      toKeep.push(cta);
    }
  });

  toKeep.forEach((cta) => {
    cta.style.display = 'none';
    cta.classList.add('cta-hidden');
    grid.appendChild(cta);
  });

  const uniqueCtaBlocks = [...grid.querySelectorAll('.image-cta-block')];
  uniqueCtaBlocks.sort((a, b) => {
    const posA = isMobile ? parseInt(a.dataset.positionMobile, 10) : parseInt(a.dataset.position, 10);
    const posB = isMobile ? parseInt(b.dataset.positionMobile, 10) : parseInt(b.dataset.position, 10);
    return posA - posB;
  });

  const visibleProducts = [
    ...grid.querySelectorAll('.bls__grid__item[data-product-index]:not([style*="display: none"])'),
  ];

  let ctaOffset = 0;
  uniqueCtaBlocks.forEach((cta) => {
    const rawPosition = isMobile
      ? parseInt(cta.dataset.positionMobile, 10)
      : parseInt(cta.dataset.position, 10);

    if (!Number.isFinite(rawPosition) || rawPosition < 1) return;

    let adjustedIndex = rawPosition - 1 - ctaOffset;

    if (isMobile) {
      if (cta.classList.contains('hide-mobile')) {
        cta.style.display = 'none';
        cta.classList.add('cta-hidden');
        return;
      }

      cta.classList.remove('col-6');
      cta.classList.add('col-12');
      cta.style.setProperty('width', '100%', 'important');
      cta.style.setProperty('flex', '0 0 100%', 'important');
      cta.style.setProperty('max-width', '100%', 'important');

      if (adjustedIndex % 2 !== 0) adjustedIndex = adjustedIndex - 1;

      if (adjustedIndex >= visibleProducts.length) {
        cta.style.display = 'none';
        cta.classList.add('cta-hidden');
        return;
      }

      const target = visibleProducts[adjustedIndex];
      if (target) {
        target.before(cta);
        cta.style.display = '';
        cta.classList.remove('cta-hidden');
        ctaOffset += 1;
      }
    } else {
      if (cta.classList.contains('hide-desktop')) {
        cta.style.display = 'none';
        cta.classList.add('cta-hidden');
        return;
      }

      cta.classList.remove('col-12');
      cta.style.removeProperty('width');
      cta.style.removeProperty('flex');
      cta.style.removeProperty('max-width');

      if (adjustedIndex >= visibleProducts.length) {
        cta.style.display = 'none';
        cta.classList.add('cta-hidden');
        return;
      }

      const target = visibleProducts[adjustedIndex];
      if (target) {
        target.after(cta);
        cta.style.display = '';
        cta.classList.remove('cta-hidden');
        const colMd = parseInt(cta.className.match(/col-md-(\d+)/)?.[1], 10) || 3;
        ctaOffset += Math.round(colMd / 3);
      }
    }
  });
}

let ctaTimer;
function scheduleAdjustImageCta() {
  clearTimeout(ctaTimer);
  ctaTimer = setTimeout(adjustImageCta, 150);
}

const ctaObserver = new MutationObserver(() => {
  ctaObserver.disconnect();
  setTimeout(() => {
    adjustImageCta();
    const productGrid = document.querySelector('#bls__product-grid');
    if (productGrid) {
      ctaObserver.observe(productGrid, { childList: true, subtree: false });
    }
  }, 400);
});

document.addEventListener('DOMContentLoaded', () => {
  adjustImageCta();
  const productGrid = document.querySelector('#bls__product-grid');
  if (productGrid) {
    ctaObserver.observe(productGrid, { childList: true, subtree: false });
  }
});

window.addEventListener('resize', scheduleAdjustImageCta);
